import moment from "moment";

const dateFormat = "DD / MM / YYYY";
const dateTimeFormat = "DD / MM / YYYY HH:mm";

export const parseDate = (date) => {
  if (!date) return "-";
  const m = moment(date);
  if (!m.isValid()) return "-";

  // Vérifier si la chaîne d'origine contient une heure
  const hasTime = /[T\s]\d{2}:\d{2}/.test(date);

  return hasTime ? m.format(dateTimeFormat) : m.format(dateFormat);
};
